<button mat-icon-button aria-label="Clear" (click)="btnClickedHandler($event)">
	<mat-icon>{{ params?.matIconLabel }}</mat-icon>
</button>
